import React from "react";
import { useLocation } from "react-router-dom";
import { useIonRouter } from "@ionic/react";
import appLogo from "./logo.png";
import homeIcon from "./home.png";
import profileIcon from "../src/assets/images/Clipped.svg";
import "./CommonHeader.css";

const CommonHeader = () => {
  const ionRouter = useIonRouter();
  const location = useLocation();
  const source = localStorage.getItem("app_source");
  const stateFrom = location.state?.from;
  const query = new URLSearchParams(location.search);
  const queryFrom = query.get("from");
  const from = stateFrom || queryFrom;

  const showHomeIcon =
    from === "pb-home" || from === "partial-menu" || source === "pb";
  const showVitalHeader = from === "vital-partial-menu";

  if (showVitalHeader) return null;

  return (
    <div className="common-header">
      {showHomeIcon ? (
        <img
          src={homeIcon}
          alt="Home"
          className="header-icon"
          onClick={() => ionRouter.push("/pb-home", "back", "push")}
        />
      ) : (
        <>
          <img src={appLogo} alt="Logo" className="header-logo" />
          <div
            className="header-profile"
            onClick={() => ionRouter.push("/profile", "forward", "push")}
          >
            <img src={profileIcon} alt="Profile" />
          </div>
        </>
      )}
    </div>
  );
};

export default CommonHeader;
